import { useEffect, useLayoutEffect } from 'react';
import type { UseEnhancedEffect } from './types';

const useEnhancedEffect: UseEnhancedEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect;

export default useEnhancedEffect;
